/**
 * Meta Pixel Tracking Utility
 * Handles all Meta Pixel events for MMB funnel tracking
 */

const isFbqAvailable = () => {
  return typeof window !== 'undefined' && typeof window.fbq === 'function';
};

const logTrackingEvent = (eventName, eventData = {}) => {
  if (process.env.REACT_APP_ENVIRONMENT === 'LOCAL' || process.env.NODE_ENV === 'development') {
    console.log(`[Meta Pixel] ${eventName}:`, eventData);
  }
};

export const trackPageView = () => {
  if (isFbqAvailable()) {
    window.fbq('track', 'PageView');
    logTrackingEvent('PageView');
  }
};

export const trackRegistrationPageView = () => {
  if (isFbqAvailable()) {
    window.fbq('track', 'ViewContent');
    logTrackingEvent('ViewContent - Registration Page');
  }
};

export const trackCompleteRegistration = (userData = {}) => {
  if (isFbqAvailable()) {
    const eventData = {
      content_name: 'User Registration',
      ...userData,
    };
    window.fbq('track', 'CompleteRegistration', eventData);
    logTrackingEvent('CompleteRegistration', eventData);
  }
};

export const trackLead = (leadData = {}) => {
  if (isFbqAvailable()) {
    const eventData = {
      content_name: 'Lead Generated',
      content_category: 'loan_application',
      ...leadData,
    };
    window.fbq('track', 'Lead', eventData);
    logTrackingEvent('Lead', eventData);
  }
};

export const trackOfferShown = (offerData = {}) => {
  if (isFbqAvailable()) {
    const eventData = {
      content_name: 'Loan Offer Shown',
      content_category: 'loan_offer',
      value: offerData.loanAmount || 0,
      currency: 'INR',
      ...offerData,
    };
    window.fbq('trackCustom', 'OfferShown', eventData);
    logTrackingEvent('OfferShown', eventData);
  }
};

export const trackOfferApproved = (approvalData = {}) => {
  if (isFbqAvailable()) {
    const eventData = {
      content_name: 'Loan Offer Approved',
      content_category: 'loan_approval',
      value: approvalData.approvedAmount || 0,
      currency: 'INR',
      ...approvalData,
    };
    window.fbq('trackCustom', 'Offerapproved', eventData);
    logTrackingEvent('OfferApproved', eventData);
  }
};

export const trackDisbursed = (disbursalData = {}) => {
  if (isFbqAvailable()) {
    const eventData = {
      content_name: 'Loan Disbursed',
      content_category: 'loan_disbursal',
      value: disbursalData.disbursedAmount || 0,
      currency: 'INR',
      ...disbursalData,
    };
    window.fbq('trackCustom', 'Disbursed', eventData);
    logTrackingEvent('Disbursed', eventData);
  }
};

export const trackCustomEvent = (eventName, eventData = {}) => {
  if (isFbqAvailable()) {
    window.fbq('trackCustom', eventName, eventData);
    logTrackingEvent(`Custom: ${eventName}`, eventData);
  }
};

export const trackStandardEvent = (eventName, eventData = {}) => {
  if (isFbqAvailable()) {
    window.fbq('track', eventName, eventData);
    logTrackingEvent(`Standard: ${eventName}`, eventData);
  }
};

export const MetaPixelTracker = {
  trackPageView,
  trackRegistrationPageView,
  trackCompleteRegistration,
  trackLead,
  trackOfferShown,
  trackOfferApproved,
  trackDisbursed,
  trackCustomEvent,
  trackStandardEvent,
};

export default MetaPixelTracker;
